import * as React from 'react';

import {AddingItemContainer} from './adding-item-container';
import {EntityPageAddItemButton} from './entity-page-add-item-button';
import type {SectionEntity} from './types';

type Props = {
    // Section entity
    sectionEntity: SectionEntity;
    // Component that the add button turns into when clicked
    addItemComponent?: React.ReactNode;
    // Used as `+ Add [parentItemText] [entityType]`
    parentItemText?: React.ReactNode;
    omitEntityName?: boolean;
    isAddingItem: boolean;
    setIsAddingItem: (arg1: boolean) => void;
};

export function SectionAddItemButton(props: Props) {
    const {
        sectionEntity,
        addItemComponent,
        parentItemText,
        isAddingItem,
        setIsAddingItem,
        omitEntityName,
    } = props;

    return isAddingItem ? (
        <AddingItemContainer
            sectionEntity={sectionEntity}
            onClickRemove={() => setIsAddingItem(false)}
        >
            {addItemComponent ? addItemComponent : null}
        </AddingItemContainer>
    ) : (
        <EntityPageAddItemButton
            sectionEntity={sectionEntity}
            parentItemText={parentItemText}
            omitEntityName={omitEntityName}
            onAddItem={() => setIsAddingItem(true)}
        />
    );
}
